import { ResponsiveContainer } from '@/components/layout/responsive-container';
import { Network, type ConnectionStatus } from '@capacitor/network';
import { WifiOff } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const useNetworkStatus = () => {
  const [status, setStatus] = useState<ConnectionStatus>({
    connected: true,
    connectionType: 'unknown',
  });

  useEffect(() => {
    // Load the initial network state
    Network.getStatus().then(setStatus);

    // Add a listener for network status change.
    Network.addListener('networkStatusChange', (status) => {
      console.log('Network status changed', status);
      setStatus(status);
    });

    return () => {
      Network.removeAllListeners();
    };
  }, []);

  return status;
};
export const NetworkStatusBanner = () => {
  const { t } = useTranslation();
  const { connected } = useNetworkStatus();

  // If connected, don't show the error
  if (connected) return null;

  return (
    <ResponsiveContainer className="flex w-full items-center justify-center gap-3 bg-red-600 py-3 text-white">
      <WifiOff className="size-5 shrink-0" />
      <div className="flex-1">
        <p className="text-sm font-medium">
          {t('home:errors.networkNotConnected.title')}
        </p>
        <p className="text-xs opacity-80">
          {t('home:errors.networkNotConnected.description')}
        </p>
      </div>
    </ResponsiveContainer>
  );
};
